import Vue from 'vue';

export default [
    {
        pathId: 'stm',
        component: 'sales-tax-menu',
        title: 'Sales Tax',
        icon: 'fa-file-invoice-dollar',
        size: 'sm'
        },
    {
        pathId: 'pptx',
        component: 'payment-plan-taxes',
        title: 'Payment Plan Taxes',
        icon: 'fa-file-invoice-dollar',
        size: 'md',
        reload: true,
        loading: true
    },
    {
        pathId: 'strr',
        component: 'sales-tax-report-results',
        title: 'Sales Tax Report Results',
        icon: 'fa-chart-bar',
        size: 'md',
        reload: true,
        loading: true,
        props: ['startDate', 'endDate', 'transactionTypes']
    },
    {
        pathId: 'not',
        component: 'new-other-transaction',
        title: 'New Other Transaction',
        icon: 'fa-plus',
        size: 'md'
    },
];

Vue.component('sales-tax-menu', () => import('@/cards/sales_tax/SalesTaxMenu'));
Vue.component('payment-plan-taxes', () => import('@/cards/sales_tax/PaymentPlanTaxes'));
Vue.component('sales-tax-report-results', () => import('@/cards/sales_tax/SalesTaxReportResults'));
Vue.component('new-other-transaction', () => import('@/cards/sales_tax/NewOtherTransaction'));
